import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import CompanyList from "./pages/CompanyList";
import Cp204Compliance from "./pages/Cp204Compliance";
import TaxComputation from "./pages/TaxComputation";
import SavedComputations from "./pages/SavedComputations";
import ETaxFiling from "./pages/ETaxFiling";
import Reports from "./pages/Reports";
import UsersPage from "./pages/UsersPage";
import TokensPage from "./pages/TokensPage";
import { Toaster } from "./components/ui/toaster";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="company" element={<CompanyList />} />
              <Route path="cp204" element={<Cp204Compliance />} />
              <Route path="company/:id" element={<Navigate to="tax" replace />} />
              <Route path="company/:id/tax" element={<TaxComputation />} />
              <Route path="company/:id/computations" element={<SavedComputations />} />
              <Route path="tax" element={<TaxComputation />} />
              <Route path="efiling" element={<ETaxFiling />} />
              <Route path="reports" element={<Reports />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="tokens" element={<TokensPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
